import { ProductType } from '../../types';
import React from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { T } from '../../Services/Localization';
import { BOX_TYPES, INSIDE_TYPES } from '../../store/data';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    // paddingTop: '56.25%', // 16:9
    paddingTop: '100%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing(1),
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

// TODO: get from store;
const boxTypes: Record<number, string> = {};
BOX_TYPES.forEach(type => (boxTypes[type.id] = type.title));

const insideTypes: Record<number, string> = {};
INSIDE_TYPES.forEach(type => (insideTypes[type.id] = type.title));

const productTypes = ['', '2LP', 'Mini LP', '2CD'];
const musicGenres = ['', 'Rock Music', 'Jazz', 'Country Music'];

type ProductProps = {
  item: ProductType;
};

const Product: React.FC<ProductProps> = (props: ProductProps) => {
  const classes = useStyles();
  const { item } = props;

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const imageLink =
    (item.image && item.image.src) ||
    'http://placekitten.com/300/300?' + Math.random();

  return (
    <Card className={classes.card} square={true}>
      <CardMedia
        className={classes.cardMedia}
        image={imageLink}
        title={`${item.author} - ${item.title}`}
      />
      <CardContent style={{ paddingBottom: 16 }}>
        <Typography className={classes.title} color="textSecondary">
          {item.author}
        </Typography>
        <Typography variant="h6" gutterBottom noWrap>
          {item.title}
        </Typography>
        <Grid
          container
          alignContent={'flex-end'}
          direction="row"
          justify="space-between"
          alignItems="flex-end">
          <Grid item xs={7}>
            <Typography
              className={classes.pos}
              variant={'caption'}
              color="textSecondary">
              {boxTypes[item.boxType]} {item.year} ({item.country})
            </Typography>
            <br />
            <Typography
              style={{ textAlign: 'end' }}
              className={classes.pos}
              variant={'caption'}
              color="textSecondary">
              {item.insideType &&
                item.insideType.map(type => insideTypes[type]).join(', ')}
            </Typography>
          </Grid>
          <Grid item xs={5} style={{ textAlign: 'end' }}>
            {item.price && (
              <Button size="medium">
                {item.price} {T('site.currency.uah')}
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Product;
